import io from "socket.io-client";
import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Form, ListGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { RoomContext } from "../App";
import { NicknameContext } from "../App";
import { socket } from "../App";
import "../index.css";
import { signOut } from "firebase/auth";

import { auth, provider } from "../firebase";
import { signInWithPopup } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import {collection} from "firebase/firestore"


import { InputGroup } from "react-bootstrap";
import { Game } from "./game";
import { RoomMenu } from "./roommenu";
import { Lobby } from "./lobby";
import { Card } from "react-bootstrap";
import previewGif from "../gamePreview.gif";
import { Image } from "react-bootstrap";

import  pinkPenguin from "../pinkPenguin.webp";
import sketchPenguin from "../penguin-drawing.jpg"
import pinkCloud from "../pinkCloud.png"
import {UserContext} from "../App"
import {db} from "../firebase"
import { doc, getDoc, addDoc, getDocs, updateDoc } from "firebase/firestore";
import {query,where} from "firebase/firestore"
import {Dropzone, FileMosaic} from "@files-ui/react"
import { InputFilesContext } from "../App";
import {Post} from "./post"



export const Profile = () => {

    const {user} = useContext(UserContext)
    const [posts, setPosts] = useState([])
    const navigate = useNavigate();

    useEffect(() => {
        const getPosts = async () => {
            const q = query(collection(db, "posts"), where("nickname", "==", user.displayName));
            console.log(q)
            const querySnapshot = await getDocs(q);
            setPosts([])
            querySnapshot.forEach((doc) => {
                console.log(doc.data());
                setPosts(prev => [...prev, doc.data()]);
            });
        }
        getPosts()
    }, [])

    return (
        <div>
                     <h1
            className=" mb-4 mt-4"
            style={{ textAlign: "left", cursor: "pointer" }}
            onClick={() => navigate("/")}
          >
            Photofusion <span style={{ fontSize: "0.5em" }}>beta</span>
          </h1>
            <h3>your saved images</h3>
<Container>
    <Row lg={6}>
        
            {posts.map((post, index) => {
                if (post.type != "fusion" || post.hide == "true" || post.hide == true) {
                    return;
                }
                return (
                    <Col xs={10} md={6} lg={4}>
                        <Post id={post.id}/>
                    </Col>
                )
            })}
            </Row>
            </Container>
            
        </div>
    )
}






































































